export default __webpack_public_path__ + "static/media/arrow_out_medium.69fbe0b0.svg";